/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import { getUpdatedOptionsList } from "../../../../utils/optionsList";
import CheckBox from "../../../shared-ui/checkbox";
//import BannerError from "../../../shared-ui/errors/error-banner";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../../utils/userResponse";

// Interface Multiple Selection  With None Component Props
interface MultipleSelectionWithNoneComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  errorMsg?: any;
  whyQuestionList: [];
  listOfAnswers: string[];
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
  dependent?: any;
  cmDependent?: any;
  //t?: any;
}

// Interface Multiple Selection With None Component state
interface MultipleSelectionWithNoneComponentState {
  errorMsg?: string;
  isPopupOpen: boolean;
  optionsList: any;
  isError: boolean;
  questionTitleState: string;
  // displayBanner: boolean;
}

/**
 * Used for any answer type is in a multiple selection.
 *
 * @namespace MultipleSelectionComponent
 */

class MultipleSelectionWithNoneComponent extends React.Component<
  MultipleSelectionWithNoneComponentProps,
  MultipleSelectionWithNoneComponentState
> {
  constructor(props: MultipleSelectionWithNoneComponentProps) {
    super(props);
    this.state = {
      isPopupOpen: false,
      optionsList: [],
      isError: false,
      questionTitleState: "",
      //displayBanner: false,
    };
  }

  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setPreFillData(recoValuesData);
    } else {
      const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
      data.forEach(function (item: {
        isChecked: boolean;
        isDisabled: boolean;
      }) {
        item.isChecked = false;
        item.isDisabled = false;
      });
      this.setState({
        optionsList: data,
        questionTitleState: this.props.questionTitle,
      });
    }
  };

  // componentDidUpdate = () => {
  //   const { listOfAnswers } = this.props;
  //   const { optionsList } = this.state;
  //   const data: any = getUpdatedOptionsList(listOfAnswers);
  //   data.forEach(function (item: { isChecked: boolean }) {
  //     item.isChecked = false;
  //   });
  //   /*This code will be required if checkbox state has to retained after language change*/
  //   //  const updatedOptions=_.omit(optionsList,['value']);
  //   // let result = _.values(_.merge(_.keyBy(updatedOptions, 'id'), _.keyBy(data, 'id')));
  //   //const equal=_.isEqual(result,optionsList);
  //   let listOfAnswersProps = data.map(function (element: any) {
  //     return element.value;
  //   });
  //   let listOfAnswersState = optionsList.map(function (element: any) {
  //     return element.value;
  //   });
  //   const equal = _.isEqual(listOfAnswersProps, listOfAnswersState);
  //   if (!equal) {
  //     this.setState({
  //       optionsList: data,
  //       isError: false,
  //       // displayBanner: false,
  //     });
  //   }
  // };

  componentDidUpdate = () => {
    const { listOfAnswers } = this.props;
    const data: any = getUpdatedOptionsList(listOfAnswers);
    data.forEach(function (item: { isChecked: boolean }) {
      item.isChecked = false;
    });
    if (this.props.questionTitle !== this.state.questionTitleState) {
      this.setState({
        questionTitleState: this.props.questionTitle,
        optionsList: data,
        isError: false,
      });
      let recoValuesData: any = getPreFillDataByContentKey(
        this.props.contentTypeId
      );
      if (recoValuesData) {
        this.setPreFillData(recoValuesData);
      }
    }
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoValuesData: any) => {
    let isNone: boolean = false;
    const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
    _.map(data, (item: any, index: any) => {
      if (_.includes(recoValuesData.recoValues, item.id)) {
        item.isChecked = true;
        if (index === data?.length - 1) {
          isNone = true;
        }
      } else {
        item.isChecked = false;
      }
      if (index === data?.length - 1) {
        if (isNone) {
          data.forEach(function (item: any, index: Number) {
            item.isChecked = data.length - 1 === index ? true : false;
            item.isDisabled = data.length - 1 === index ? false : true;
          });
        } else {
          item.isChecked = false;
          item.isDisabled = true;
        }
      }
    });
    this.setState({
      optionsList: data,
    });
  };

  /**
   * This method is used for handling error
   *
   */

  handleError = () => {
    const { optionsList } = this.state;
    const filteredOptions = optionsList.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    if (filteredOptions === optionsList.length) {
      this.setState({
        isError: true,
        //displayBanner: true,
      });
    } else {
      this.setState(
        {
          isError: false,
          //displayBanner: false,
        },
        () => {
          if (this.props.dependent || this.props.cmDependent) {


            const data: any = this.getSelectedData();
            // const { conditions, dependent_content_type_id } =
            //   this.props.dependent;
            // const selectedValues = data.recoValues;
            // let newArray = _.intersection(conditions, selectedValues);
            // let isValueFound: boolean = newArray.length > 0 ? true : false;
            // /*if strict checking of values is required
            // let isValueFound = _.isEqual(conditions, selectedValue);
            // */
            // this.props.handleSuccessfulContinue(
            //   false,
            //   false,
            //   dependent_content_type_id,
            //   isValueFound
            // );
            if (this.props.cmDependent && this.props.dependent) {
              const { conditions, dependent_content_type_id } = this.props.dependent;
              const selectedValues = data.recoValues;
              let newArray = _.intersection(conditions, selectedValues);
              let isValueFound: boolean = newArray.length > 0 ? true : false;
              // /*if strict checking of values is required
              // let isValueFound = _.isEqual(conditions, selectedValue);
              // */
              const addRemoveData = this.handleAddRemoveCm();

              if (isValueFound) {
                addRemoveData.valuesToRemove = _.union(dependent_content_type_id, addRemoveData.valuesToRemove);
              } else {
                addRemoveData.valuesToAdd = _.union(dependent_content_type_id, addRemoveData.valuesToAdd);
              }
              this.props.handleSuccessfulContinue(
                false,
                false,
                false,
                false,
                true,
                addRemoveData.valuesToAdd,
                addRemoveData.valuesToRemove,
              );
            } else {
              if (this.props.dependent) {
                const { conditions, dependent_content_type_id } = this.props.dependent;
                const selectedValues = data.recoValues;
                let newArray = _.intersection(conditions, selectedValues);
                let isValueFound: boolean = newArray.length > 0 ? true : false;
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  dependent_content_type_id,
                  isValueFound,
                  false,
                  false,
                  false
                );
              }
              if (this.props.cmDependent) {
                const addRemoveData = this.handleAddRemoveCm();
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  false,
                  false,
                  true,
                  addRemoveData.valuesToAdd,
                  addRemoveData.valuesToRemove,
                );
              }
            }
          } else {
            this.getSelectedData();
            this.props.handleSuccessfulContinue();
          }
        }
      );
    }
  };

  /**
* 
* handleAddRemoveCm -- data to remove or add
*/
  handleAddRemoveCm = () => {
    const cmDepList: any = this.props.cmDependent;
    const data: any = this.getSelectedData();
    const selectedValue = data?.recoValues;
    let valuesToAdd: any = [];
    let valuesToRemove: any = [];
    _.map(cmDepList, (eachData: any) => {
      if (!_.isEmpty(eachData)) {
        let newArray = _.intersection(eachData.conditions, selectedValue);
        let isCmValueFound: boolean = newArray.length > 0 ? true : false;
        if (isCmValueFound) {
          valuesToRemove.push(...eachData.dependent_content_type_id);
        } else {
          valuesToAdd.push(...eachData.dependent_content_type_id);
        }
      }
    })
    let cmData: any = {
      valuesToAdd: valuesToAdd,
      valuesToRemove: valuesToRemove
    }
    return cmData;
  }

  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData: Object = {};
    let recoValue: Array<String> = [];
    let values: Array<String> = [];
    if (!_.isEmpty(this.state.optionsList)) {
      _.map(this.state.optionsList, (data: any, index: any) => {
        if (data?.isChecked) {
          recoValue.push(data.id);
          values.push(data.value);
        }
      });
    }
    responseData = {
      contentTypeId: this.props.contentTypeId,
      recoId: this.props.recoId,
      recoValues: recoValue,
      values: values,
    };
    setUserResponse(responseData);
    return responseData;
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle Why Asking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  /**
   * This method is used to handle checkbox click
   * @param {any} evt
   * @param {string} value
   * @param {number} index
   *
   */
  handleCheckbox = (value: string, index: number, evt?: any) => {
    evt?.stopPropagation();
    if (evt && evt.charCode === 32) {
      return;
    }
    const { optionsList } = this.state;
    // const isChecked = evt.target.checked;
    const data: any = optionsList;
    //const objIndex = data.findIndex((obj: any) => obj.value === value);
    data[index].isChecked = !data[index].isChecked;
    /*This code is used to handle disabling of options*/
    const uncheckedFilteredOptions = this.state.optionsList.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    const allExceptNoneOptions = _.initial(data);
    const checkedFilteredOptions = allExceptNoneOptions.filter(
      (obj: any) => obj.isChecked === true
    ).length;
    if (
      index === optionsList.length - 1 &&
      data[optionsList.length - 1].isChecked === true
    ) {
      for (let i = 0; i < data.length - 1; i = i + 1) {
        data[i].isDisabled = true;
      }
    }
    if (checkedFilteredOptions > 0) {
      data[optionsList.length - 1].isDisabled = true;
    }
    if (uncheckedFilteredOptions === this.state.optionsList.length) {
      data.forEach((element: any) => {
        element.isDisabled = false;
      });
    }

    this.setState({ optionsList: data });

    if (uncheckedFilteredOptions !== this.state.optionsList.length) {
      this.setState({
        isError: false,
        // displayBanner: false,
      });
    }
  };
  render() {
    const { questionTitle, questionSubTitle, whyQuestionList, errorMsg } =
      this.props;
    const { optionsList, isError /*, displayBanner*/ } = this.state;
    return (
      <>
        {/* {displayBanner ? (
           <>
             <BannerError
               title={this.props.t("error.we_would_like_to_know_this")}
               sub_title={this.props.t("error.please_select_atleast_one_option")}
               handleClose={() => {
                 this.setState({ displayBanner: false, isError: false });
               }}
             />
           </>
         ) : null} */}
        <div
          /* style={{ position: "absolute" }}*/
          className="inner-wrapper mutiple-selection-container"
        >
          <WhyAskingPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            list={whyQuestionList}
          />

          <div className="question-wrappper">
            <div className="question-label">{questionTitle || ""}</div>
            <div className="question-sub-label">{questionSubTitle || ""}</div>
          </div>

          {/* Multiple answer inner wrapper Start */}
          <div className="multiple-answer-wrapper">
            <div className="answer-list-conatiner">
              <div className="checkbox-container checkbox-grid-layout">
                {optionsList && optionsList.length > 0
                  ? optionsList.map((item: any, index: number) => (
                    <div tabIndex={0} role="listitem"
                      className={
                        item && item.isDisabled
                          ? "checkbox-wrapper disable"
                          : item && item.isChecked
                            ? "checkbox-wrapper active"
                            : isError
                              ? "checkbox-wrapper checkbox-error"
                              : "checkbox-wrapper"
                      }
                      onClick={() => {
                        this.handleCheckbox(item.value, index);
                      }}
                      onKeyPress={(e) => { if (e.key === "Enter" || e.key === " ") { this.handleCheckbox(item.value, index, e) } }}
                    >
                      <CheckBox
                        className={
                          "checkbox"
                          // isError ? "checkbox checkbox-error" : "checkbox"
                        }
                        onCheckboxClick={(evt) =>
                          this.handleCheckbox(item.value, index, evt)
                        }
                        isChecked={item && item.isChecked}
                      />
                      <span
                        className={
                          item && item.isChecked
                            ? "list-label active"
                            : "list-label"
                        }
                      >
                        {item.value || ""}
                      </span>
                    </div>
                  ))
                  : null}
              </div>

              <div tabIndex={0} className={isError ? "error-msg" : "hide"}>
                {errorMsg && errorMsg.empty_error}
              </div>
            </div>
          </div>

          {/* Multiple answer wrapper Ends */}

          {whyQuestionList && whyQuestionList.length > 0 ? (
            <WhyAskingComponent
              {...this.props}
              handlePopup={this.handlePopup}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default MultipleSelectionWithNoneComponent;
